import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Discount = () => {
    document.title = "Müştəri endirimi";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Tərəf müqabillər", value: "/customers" },
        { name: "Müştəri endirimi", value: "/customers/dicount", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Müştəri endirimi</h2>
                    <p>
                        <Link to={"/supplies/supply"}>Alış</Link>, <Link to={"/demands/demand"}>satış</Link> əməliyyatları zamanı, tərəf-müqabilin (kontragent)
                        endirimini bütün məhsullara şamil etmək üçün nəzərdə tutulub.
                        <br />
                        <b>Qeyd</b>: Ayrı aryılıqda məhsula tətbiq edilən endirim silinib tərəf-müqabil (kontragent) endirimi tətbiq ediləcək.
                    </p>
                    <img src="/images/customers/discount.gif" alt="Müştəri endirimi" />
                </article>
            </div>
        </div>
    );
};
